import React from 'react';

const videos = [
  {
    src: "https://www.youtube.com/embed/MDXJlO7zrSw?si=WRoMK2crsmxFQBuG",
    title: "Zoe Pete Ford | Billy/Bobby | Whistle Inc.",
    featured: true
  },
  {
    src: "https://www.youtube.com/embed/LclkfVHOFlE?si=-MThl33Pr7DbrLdH",
    title: '"Life\'s A Cigarette" by Zoë Pete Ford (Official Music Video)',
    featured: false
  },
  {
    src: "https://www.youtube.com/embed/eQR0rgY3nwY?si=zxx8C_ahgpogNftq",
    title: '"Truckstop in my head" by Zoë Pete Ford LIVE! at Skinny Dennis in Brooklyn, NY (18JUNE2024)',
    featured: false
  },
  {
    src: "https://www.youtube.com/embed/9_ZPa0BO5P4?si=-G4MFhlD5vyjbrC2",
    title: '"Good Bad Baby" by Zoë Pete Ford LIVE! at Jones Bar (Ridgewood, Queens) July 12, 2024',
    featured: false
  },
  {
    src: "https://www.youtube.com/embed/XPUz5jJpbmk?si=NSFAGsFWlNJHrqIE",
    title: '"Backseat Beauty Queen" by Zoë Pete Ford LIVE! at Jones Bar (Ridgewood, Queens) November 22, 2024',
    featured: false
  },
  {
    src: "https://www.youtube.com/embed/b3_ksV6RV7A?si=JVhLIrYZPEpsrcYF",
    title: '"Summer of Baseball" by Zoë Pete Ford LIVE! at Metropolitan Sound (Brooklyn, NY)August 21, 2024',
    featured: false
  }
];

function Videos() {
  const featuredVideo = videos.find(video => video.featured);
  const regularVideos = videos.filter(video => !video.featured);

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      {/* Featured Video Section */}
      {featuredVideo && (
        <div style={{
          marginBottom: '40px',
          padding: '0 20px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden'
            }}>
              <iframe
                src={featuredVideo.src}
                title={featuredVideo.title}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
            <p style={{
              margin: 0,
              fontSize: '16px',
              color: '#333'
            }}>
              {featuredVideo.title}
            </p>
          </div>
        </div>
      )}

      {/* Regular Videos Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)', // Fixed 2 columns
        gap: '20px',
        padding: '20px'
      }}>
        {regularVideos.map((video, index) => (
          <div key={index} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden'
            }}>
              <iframe
                src={video.src}
                title={video.title}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: '#333'
            }}>
              {video.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Videos;
